import * as API from "utils/api"
import { APIResponse } from "./types"

const GetCacheTime: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.auth_request("GET", "Message/GetCacheTime", params, headers)
}

export default {
  GetCacheTime,
}
